import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators"; // Import map operator
import { environment } from "src/environments/environment";
import { PaymentTransaction } from "../../interfaces/payment/payment-transaction.model";

@Injectable({
  providedIn: "root",
})
export class PaymentTransactionService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  private createCompleteUrl(path: string): string {
    return `${this.apiUrl}${path}`;
  }

  getPaymentTransactions(): Observable<PaymentTransaction[]> {
    const url = this.createCompleteUrl("payment/transactions/");
    return this.http
      .get<PaymentTransaction[]>(url)
      .pipe(
        map((transactions) =>
          transactions.sort(
            (a, b) =>
              new Date(b.created_on).getTime() -
              new Date(a.created_on).getTime()
          )
        )
      );
  }
  getTransactionStatus(txId: string): Observable<PaymentTransaction> {
  const url = this.createCompleteUrl(`payment/transactions/status/${txId}`);
  return this.http.get<PaymentTransaction>(url);
}
}
